import * as Services from "../../../Service/Service"

export const ImportCensusFile = (
  clientID,
  ClientName,
  licenseId,
  UserName,
  payload,
  UserId
) => {
  const token = localStorage.getItem("token");

  let res = Services.POSTFORMDATA(
    `/api/ACG_Census/ImportCensus?ClientName=${ClientName}&CurrentLicense=${licenseId}&UserName=${UserName}&ClientID=${clientID}&UserId=${UserId}`,
    payload,
    token
  );
  return res;
};

export const DeleteClientLargeClaimUWByClientId = (clientID, UserId) => {
  const token = localStorage.getItem("token");

  let res = Services.POST(
    `/api/ACG_Census/DeleteClientLargeClaimUWByClientId/${clientID}?UserId=${UserId}`,
    '',
    token
  );
  return res;
};

export const AddMainCensusFromImportCensus = (clientID,licenseId, id, UserId) => {
  const token = localStorage.getItem("token");
 
  let res = Services.POST(
    `/api/ACG_Census/AddMainCensusFromImportCensus/${clientID}/${licenseId}/${id}?UserId=${UserId}`,
    '',
    token
  );
  return res;
};



export const DownloadCensusErrorFile = (fileName) => {
  const token = localStorage.getItem("token");
  const params = { fileName };

  let res = Services.GETSERVICE(
    `/api/ACG_Census/DownloadCensusErrorFile?filename=${fileName}`,
    params
  );
  return res;
};



// import * as Services from "../../../Service/Service";
// import * as Url from "../../../Service/Url";

// export const ImportCensusFile = async (
//   clientID,
//   ClientName,
//   UserId,
//   UserName,
//   payload
// ) => {
//   const token = localStorage.getItem("token");
//   const url = `${
//     Url.IMPORT_CENSUS + ClientName
//   }&CurrentLicense=${UserId}&UserName=${UserName}&ClientID=${clientID}`;

//   let res = await Services.POST(url, payload, token);
//   return res;
// };

// export const DownloadCensusErrorFile = async (fileName) => {
//   const token = localStorage.getItem("token");
//   let res = await Services.GET(Url.DOWNLOAD_ERROR_FILE + fileName, token);
//   return res;
// };
export const DeletePlanDeviationByClientId = (
  clientID,
  devi,
  licenseId,
  ClientName,
) => {
  const token = localStorage.getItem("token");

  let res = Services.POST(
    `/api/ACG_Census/DeletePlanDeviationByClientId/${clientID}/${devi}/${licenseId}`,
    '',
    token
  );
  return res;
};

export const GetCensusDataByClientIdwithPagging = (clientID, pageNumber, PageSize) => {
  const token = localStorage.getItem("token");

  let res = Services.POST(
    `/api/ACG_Census/GetCensusDataByClientIdwithPagging?clientId=${clientID}&PageNumber=${pageNumber}&PageSize=${PageSize}`,
    '',
    token
  );
  return res;
}


